// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  memberKey: __t.string().primaryKey().name("member_key"),
  roomId: __t.u64().name("room_id"),
  identity: __t.identity(),
  role: __t.string(),
  serverMuted: __t.bool().name("server_muted"),
  handRaised: __t.bool().name("hand_raised"),
  connected: __t.bool(),
  joinedAt: __t.timestamp().name("joined_at"),
  changedAt: __t.timestamp().name("changed_at"),
});
